<template>
  <div class="box">
    <div class="user">
    	
    </div>
  </div>
</template>

<script>
  import { getInfoByType } from '@/api/user';
  export default {
    data() {
      return {
		data:''
      };
    },
	mounted(){
		this.getInfoByType()
	},
    methods: {
	  
    }
  }

</script>

<style lang="scss" scoped>
    
</style>


// WEBPACK FOOTER //
// Yidongduanchongzhi.vue?39ff0673